import Vue from 'vue'
import Paginate from 'vuejs-paginate'

export default () => {
  Vue.component('paginate', Paginate)
}
